<template>
  <div class="carousel-container">
   
    <div class="carousel">
      <div class="carousel-track">

        <div v-for="(client, index) in displayedClients" :key="index" class="carousel-item">
          <img :src="client" alt="Client logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clients: [
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fistrian-vila.png?alt=media&token=2c1658e9-9e8e-48ed-873f-9d0802433af2",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fimage%20(1).png?alt=media&token=73b76f13-0f49-4191-b06b-220fdd3812b0",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fmasterprojekt.png?alt=media&token=d046e9f9-35b7-4042-bad9-7b0f242d71bf",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Finvesteks.png?alt=media&token=2cc726cb-45c9-46d7-b034-805f61a9ee77",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Findex_black_effect.png?alt=media&token=13103d3f-08e2-4aa0-bcf1-e4576e9850f1",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fsunyhill.png?alt=media&token=21a50e30-ec5f-433c-a198-476e6657aa59",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2FlogoverticalPropGuard.png?alt=media&token=01e46596-a5ef-49b9-920f-e1a98250a0ce",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2FKader-Kicaj-removebg-preview.png?alt=media&token=54c9747d-3ac2-4e19-b2e5-0ef791ee5358",
         "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fvriora_no_background.jpg?alt=media&token=1a2748f0-0a6a-44e5-9824-4435d3852f75",
        "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fsaveconst.png?alt=media&token=0bcc4516-dea4-435c-a142-942506e987c1",
        "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fekoplanet.png?alt=media&token=f4e2a872-f5a2-41e0-96df-bbd4adaf493d",
        "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fbonsalt_logo.png?alt=media&token=77723ddd-94f7-48d9-9644-ce036a1c2243",
        "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Fcropped-Logo_ime_pero_vece-291x109.png?alt=media&token=77a8d110-84dc-4b85-8209-3427681ba874",
        "https://firebasestorage.googleapis.com/v0/b/masterprojekt-ba7a5.appspot.com/o/MasteBit%2Fclients%2Flogotip_VIGO_vektorji.png?alt=media&token=94aba010-d769-419c-b1f7-3abc45782ede",
      ],
    };
  },
  computed: {
    // Dupliramo niz klijenata da bismo napravili efekt loopa
    displayedClients() {
      return [...this.clients, ...this.clients];
    },
  },
};
</script>

<style scoped >
.carousel-container {
text-align: left; /* Poravnanje teksta na levo */
margin-top: 20px;
}

h2 {
color: #ebe9e9;
margin-left: 43%;
font-size: 1.5em;
margin-bottom: 20px;
padding-bottom: 50px;
}

.carousel {
overflow: hidden;
width: 100%; /* Širina u odnosu na ekran */
margin: 0;
border-radius: 10px;
}

.carousel-track {
display: flex;
justify-content: flex-start; /* Poravnanje na levo */
width: max-content; /* Traka sa širinom koja raste koliko je potrebno */
animation: scroll 20s linear infinite; /* Glatka animacija bez resetovanja */
}

.carousel-item {
flex: 0 0 auto;
width: 200px; /* Veći logotipi */
padding: 10px;
}

.carousel-item img {
width: 150px;
opacity: 1;
height: auto;
opacity: 0.7;
opacity: 1;
}

.carousel-item img:hover {
opacity: 1; /* Vidljivost 100% na hover */
}

/* Animacija za beskonačnu traku koja ulazi s jedne i izlazi s druge strane */
@keyframes scroll {
0% {
  transform: translateX(0);
}
100% {
  transform: translateX(-50%);
}
}



/* Prilagođavanje za vrlo male uređaje (npr. mobilni telefoni ispod 480px) */
@media (max-width: 480px) {
h2 {
  margin-left: 35%; /* Dalje centriranje naslova za još manje ekrane */
  font-size: 1.1em;
  padding-bottom: 10px;
}

.carousel-item {
  width: 120px; /* Još manji logotipi */
  padding: 10px;
}

.carousel-item img {
  max-width: 100px; /* Još manje logotipi */
  max-height: 80px;
}
}

</style>
